import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const SuperAdminRoute: React.FC = () => {
  const { entityName } = useParams<{ entityName: string }>();
  const user = useSelector((state: RootState) => state.user.user);
  const isAuthenticated = useSelector((state: RootState) => state.user.userAuth);

  // Check if user is authenticated and is super admin
  if (!isAuthenticated) {
    return <Navigate to={`/${entityName}`} />;
  }

  if (user.user_type !== "super_admin") {
    return <Navigate to="/403" />;
  }

  // Check if user is accessing from Weitz tenant only
  if (entityName?.toLowerCase() !== "weitz") {
    return <Navigate to="/403" />;
  }

  // Additional check: Super admin should only be from Weitz tenant (no city_id or ao_id)
  if (user.city_id || user.ao_id) {
    return <Navigate to="/403" />;
  }

  return <Outlet />;
};

export default SuperAdminRoute;